import * as React from 'react';

import { SpecialOfferActionContext, SpecialOfferValueContext } from './context';
import { useSpecialOfferAction, useSpecialOfferValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const SpecialOfferFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <SpecialOfferValueContext.Provider value={state}>
      <SpecialOfferActionContext.Provider value={dispatch}>
        {children}
      </SpecialOfferActionContext.Provider>
    </SpecialOfferValueContext.Provider>
  );
};

export { SpecialOfferFormContext, useSpecialOfferAction, useSpecialOfferValue };
